import { LazyLoader } from '@bp/ui-components';
import { graphql } from 'client/gql';
import { useAuthClaims } from 'hooks/useAuthClaims';
import { usePermissionChecker } from 'hooks/usePermissionChecker';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { useQuery } from 'urql';
import { BpPage } from '../../components/BpPage/BpPage';
import {
  DesktopNavigationTabs,
  type DesktopNavigationTabsType,
} from '../../components/NavigationTabs/Desktop/DesktopNavigationTabs';

export function AdminPage() {
  const { t } = useTranslation();
  const { pimAuthClaims } = useAuthClaims();
  const permissions = usePermissionChecker();

  const tabs: DesktopNavigationTabsType[] = [
    {
      title: t('admin.title'),
      path: '/admin',
      pathMatchEnd: true,
    },
    ...(permissions?.isOmniAdmin()
      ? [
          {
            title: t('institution.admin'),
            path: 'admin',
          },
        ]
      : []),
    ...(permissions?.isOmniAdmin()
      ? [
          {
            title: t('organizations.title', { count: 2 }),
            path: 'organizations',
          },
        ]
      : []),
  ];

  return (
    <BpPage
      title={t('admin.title')}
      isForbidden={!permissions?.isOmniAdmin()}
      organization={pimAuthClaims.getOrganization()}
    >
      <DesktopNavigationTabs tabs={tabs} className='mb-6' />
      <Suspense fallback={<LazyLoader embedded transparent forceHeight='45vh' />}>{<Outlet />}</Suspense>
    </BpPage>
  );
}
